import {queryOptions} from '@tanstack/react-query';

import {groupsEventsList, groupsEventsRetrieve} from 'api/v2';

export const groupsEventsQueryKeys = {
  all: () => ['group-events'],
  detail: (id: string) => [...groupsEventsQueryKeys.all(), 'detail', id],
};

const groupsEventsDetail = (groupId: string, id: string) =>
  queryOptions({
    queryKey: groupsEventsQueryKeys.detail(id),
    queryFn: () => groupsEventsRetrieve(groupId, id),
    select: (data) => data.data,
  });

const groupsEventsAll = (groupId: string) =>
  queryOptions({
    queryKey: groupsEventsQueryKeys.all(),
    queryFn: () => groupsEventsList(groupId),
    select: (data) => data.data.results,
  });

export const groupsEventsQueryOptions = {
  list: groupsEventsAll,
  detail: groupsEventsDetail,
};
